import map from "ramda/src/map";
import prop from "ramda/src/prop";
import join from "ramda/src/join";
import compose from "ramda/src/compose";

export const normalizeNetworks = compose(join(""), map(prop("l1Id")));
